import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import { BrandBand } from '../../common/components';
import { Header, McMenu, Analytics } from '../components/';
import {
  Button,
  Card,
  PageHeaderControl,
  Popover,
  Spinner
} from '@salesforce/design-system-react';

// import './AnalyticsRoot.scss';
import { Link } from 'react-router-dom';

export class AnalyticsRoot extends Component {
  constructor(props) {
    super(props);
    this.selectionBrowserButton = this.selectionBrowserButton.bind(this);
    this.state = {
      isLoading: true
    };
  }

  componentDidMount() {
    // // TODO: can we bootstrap what we need with fewer API calls?
    // this.props.actions.getAssetTypes();
    // this.props.actions.getAssetAttributes();
    // this.props.actions.getAssetSummary();
    // this.props.actions.getAssetDistributionByKey('type');
    // this.props.actions.getAttributes();
    // this.props.actions.getRules();
  }

  selectionBrowserButton() {
    const { formatMessage } = this.props.intl;
    const selectionLearnLink =
      'https://help.salesforce.com/articleView?id=sf.mc_pb_find_out_why_an_asset_was_selected.htm&type=5';
    const button = (
      <Link to={{ pathname: '/selections' }}>
        <Button id="view-selections" variant="neutral">
          <FormattedMessage id="components.ecs.analytics.header.button.label" />
        </Button>
      </Link>
    );

    const selectionBrowserButton = localStorage.getItem(
      'selectionBrowserPopoverDismissed'
    ) ? (
      button
    ) : (
      <Popover
        className="selection-browser-popover"
        variant="feature"
        align="bottom right"
        heading={formatMessage({
          id: `components.ecs.analytics.header.button.popoverHeader`
        })}
        body={
          <div>
            <p>
              {formatMessage({
                id: `components.ecs.analytics.header.button.popoverText`
              })}
            </p>
          </div>
        }
        footerWalkthroughActions={
          <Button
            onClick={event => {
              window.open(selectionLearnLink, '_blank', 'noopener noreferrer');
            }}
            variant="neutral"
          >
            {formatMessage({
              id: `components.ecs.analytics.header.button.popoverCTA`
            })}
          </Button>
        }
        isOpen={!this.state.isPopoverDismissed}
        onRequestClose={() => {
          this.setState({ isPopoverDismissed: true });
          localStorage.setItem('selectionBrowserPopoverDismissed', true);
        }}
        {...this.props}
      >
        {button}
      </Popover>
    );

    return () => (
      <PageHeaderControl>{selectionBrowserButton}</PageHeaderControl>
    );
  }

  renderSpinner() {
    return (
      <div className="spinner-container">
        <Spinner variant="brand" />
      </div>
    );
  }

  render() {
    const headerActions = this.selectionBrowserButton();

    return (
      <McMenu
        flags={this.props.flags}
        history={this.props.history}
        route="/analytics"
      >
        <BrandBand>
          <Header route={this.props.match} onRenderActions={headerActions} />
          <Card className="content-selection-root-card" hasNoHeader>
            <Analytics {...this.props} />
          </Card>
        </BrandBand>
      </McMenu>
    );
  }
}

AnalyticsRoot.contextTypes = {
  router: PropTypes.object
};

AnalyticsRoot.propTypes = {
  assets: PropTypes.object,
  attributes: PropTypes.object,
  actions: PropTypes.object,
  flags: PropTypes.object,
  modals: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  const { ecs, welcomeMat, ...others } = state;
  return {
    flags: state.ecs.flags,
    ...ecs,
    welcomeMat: welcomeMat.ecs,
    ...others
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AnalyticsRoot)
);
